
import { defineComponent } from 'vue';
import { AppFormRow, AppFileUpload, AppCard, AppButton } from '@/components';
import { useAvatarImport } from '@/modules/avatar/import/model/import';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.IMPORT,
    components: { AppFormRow, AppFileUpload, AppCard, AppButton },
    setup() {
        const { model, importFile } = useAvatarImport();

        return { model, importFile };
    }
});
